import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-renwu",
  "use": "icon-renwu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-renwu\"><path fill=\"currentColor\" d=\"M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM676 608H348c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h328c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8zM676 432H348c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h328c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8zM676 784H348c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h328c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/renwu.svg
// module id = Czf/
// module chunks = 96